import { listedConversationRecords } from 'dashboard/permissionSets/conversationReads';
import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { replaceExisting = false, countRequest } = {}
) => {
  const { payload, meta: metaData } = responseData;
  const conversationList = listedConversationRecords(
    context.rootState,
    payload
  );
  if (replaceExisting) {
    context.dispatch('conversationPage/reset', null, { root: true });
    context.commit(types.REPLACE_CONVERSATION_LIST, conversationList);
  } else {
    context.commit(types.SET_ALL_CONVERSATION, conversationList);
  }
  context.dispatch('conversationStats/set', {
    meta: metaData,
    request: countRequest,
  });
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !payload.length,
  });
};
